import { getDevice } from "./getdevice";
import { Project } from "./project";
import { Objects } from "./object";

export class Protocol {
    communicationstartswith: string;
    valueseprator: string;
    recordseprator: string;
    communicationendswith: string;
    getdevice: getDevice; 
    Objects:Objects[]
      }
 